// @flow
import type { FetchedCurrencies } from "@kiwicom/nitro/lib/records/Currency"

export default function(amount: number, currency: string, currencies: FetchedCurrencies) {
  // toLowerCase to make sure always lower case
  return parseFloat(
    (amount / currencies[currency].rate).toFixed(Number(currencies[currency].precision)),
  )
}
